import Restrictions from '../models/medialRestrictions'
import { POST_TYPE, SOCIAL_NETWORK } from '../models/post'

type PostRestrictionHandlerProps = {
  social: SOCIAL_NETWORK
  postType: POST_TYPE
}

enum MEDIA_TYPE {
  VIDEO = 'video',
  IMAGE = 'image'
}

export class PostRestrictionHandler {
  social: SOCIAL_NETWORK
  postType: POST_TYPE

  constructor({
    social = SOCIAL_NETWORK.FACEBOOK_SOCIAL,
    postType = POST_TYPE.POST_TYPE_SINGLE_PHOTO
  }: PostRestrictionHandlerProps) {
    this.social = social
    this.postType = postType
  }

  getContentRestrictions = () => {
    const contentRestrictions = Restrictions[this.social].content_restrictions[this.postType]
    const mediaRestrictionsByType = Restrictions[this.social].media_restrictions[this.postType]
    const defaultMediaRestrictions = Restrictions[this.social].media_restrictions.default

    const isInculeMediaType = (mediaType: MEDIA_TYPE) =>
      !!mediaRestrictionsByType && Object.keys(mediaRestrictionsByType).includes(mediaType)

    const mediaRestrictions: { [key in MEDIA_TYPE]: any } = {
      [MEDIA_TYPE.IMAGE]: isInculeMediaType(MEDIA_TYPE.IMAGE)
        ? {
            ...defaultMediaRestrictions[MEDIA_TYPE.IMAGE],
            ...mediaRestrictionsByType[MEDIA_TYPE.IMAGE]
          }
        : null,
      [MEDIA_TYPE.VIDEO]: isInculeMediaType(MEDIA_TYPE.VIDEO)
        ? {
            ...defaultMediaRestrictions[MEDIA_TYPE.VIDEO],
            ...mediaRestrictionsByType[MEDIA_TYPE.VIDEO]
          }
        : null
    }

    return {
      ...contentRestrictions,
      mediaRestrictions
    }
  }

  logRestrictions = () => {
    console.log('_Restrictions [', this.social, '] = ', Restrictions[this.social])
  }
}
